import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import {
	ApAuthenticationContextProvider,
	Telemetry,
} from '@alixpartners/ui-utils';

import injectGlobalStyles from 'styles/injectGlobalStyles';
import WindowSize from 'components/WindowSize';
import { FeatureFlagsContextProvider } from 'contexts/FeatureFlagsContext/FeaturesFlagsContextProvider';
import AuthenticationError from 'components/AuthenticationError';
import { App } from 'App';
import { LicenseManager } from '@ag-grid-enterprise/all-modules';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css';
import 'react-tippy/dist/tippy.css';
import 'rc-slider/assets/index.css';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({ basename: '' });
Telemetry.setup(process.env.REACT_APP_AI_KEY, browserHistory);

if (process.env.REACT_APP_AG_GRID_LICENSE) {
	LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE);
}

injectGlobalStyles();

const Root = () => {
	return (
		<WindowSize>
			{({ width, height }) => (
				<div style={{ width, height }}>
					<Router history={browserHistory}>
						<FeatureFlagsContextProvider>
							<ApAuthenticationContextProvider
								errorComponent={AuthenticationError}
							>
								<App />
							</ApAuthenticationContextProvider>
						</FeatureFlagsContextProvider>
					</Router>
				</div>
			)}
		</WindowSize>
	);
};
ReactDOM.render(<Root />, document.getElementById('root'));
